import { useInventoryData } from "../../../../../hooks/use-inventory-data";


export function useInventoryDataProvider() {
  const {
    champignons,
    especes,
    nuisibles,
    isLoading,
    hasError,
    champignonsError,
    especesError,
    nuisiblesError,
  } = useInventoryData(true);

  return {
    champignons,
    especes,
    nuisibles,
    isLoadingInventoryData: isLoading,
    hasInventoryDataError: hasError,
    champignonsError: champignonsError ?? undefined,
    especesError: especesError ?? undefined,
    nuisiblesError: nuisiblesError ?? undefined,
  };
}

